import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";

export const useRivePreload = ({src, locale = false, module = false}) => {
  const {i18n} = useTranslation()

  const
    name = 'blob_' + src.split('/').pop().split('.').slice(0, -1).join('.'),
    path =
      src.includes('/static/') || src.startsWith('blob:')
        ? src
        : (
          module
            ? `/${process.env.REACT_APP_MODULE}/static/${locale ? 'i18/' + i18n.resolvedLanguage + '/' : ''}rive/${src}`
            : `/static/${locale ? 'i18/' + i18n.resolvedLanguage + '/' : ''}rive/${src}`
            // ? require(`module/${process.env.REACT_APP_MODULE}/assets/${locale ? 'i18/' + i18n.resolvedLanguage + '/' : ''}rive/${src}`)
            // : require(`assets/${locale ? 'i18/' + i18n.resolvedLanguage + '/' : ''}rive/${src}`)
        )

  const [blobUrl, setBlobUrl] = useState(window[name])

  useEffect(() => {
    window[name] = blobUrl
  }, [blobUrl])

  return {
    path,
    blobUrl, setBlobUrl,
    prefetch: <link rel="prefetch" href={path} as="fetch" crossOrigin="anonymous"/>
  }
}